import { render } from "./ShowDiscount.vue?vue&type=template&id=de990002&scoped=true"
import script from "./ShowDiscount.vue?vue&type=script&lang=js"
export * from "./ShowDiscount.vue?vue&type=script&lang=js"

import "./ShowDiscount.vue?vue&type=style&index=0&id=de990002&scoped=true&lang=css"

import exportComponent from "/home/u624473994/domains/backoffice.quickpay.pe/quickshop-admin-main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de990002"]])

export default __exports__